import { ComboBox, IComboBoxOption } from "@fluentui/react";
import React, { useState, useRef } from "react";
import { ReactNode } from "react";
import { IDataSource } from "./IDataSource";
import { IJobParameterControl } from "./IJobParameterControl";

export function ControlledMultiselectComboBox(props: {
  caption: string;
  options: { code: string; description: string }[];
  defaultValue: string[];
  onSelectionChange: (selectedKeys: string[]) => void;
}) {
  const [selectedKeys, setSelectedKeys] = useState<string[]>([...props.defaultValue]);
  const lastChangeRef = useRef({ key: '', time: 0 });

  const handleChange = (e: any, o?: IComboBoxOption) => {
    if (!o) return;
    const key = o.key + "";
    const now = Date.now();

    if (key === lastChangeRef.current.key && now - lastChangeRef.current.time < 2000) return;
    lastChangeRef.current = { key, time: now };

    const next = o.selected
      ? [...selectedKeys.filter(k => k !== key), key]
      : selectedKeys.filter(k => k !== key);

    setSelectedKeys(next);
    props.onSelectionChange(next);
  };

  return (
    <div className="dropdownDataInput">
      <ComboBox
        multiSelect
        label={props.caption}
        selectedKey={selectedKeys}
        options={props.options.map(v => ({ key: v.code, text: v.description }))}
        onChange={handleChange}
        useComboBoxAsMenuWidth
        calloutProps={{ calloutMaxHeight: 270 }}
        allowFreeform={true}
        openOnKeyboardFocus={true}
      />
    </div>
  );
}

export class MultiselectJobParameterControl
  implements IJobParameterControl<string>
{
  CurrentValue: string[] = [];
  DefaultValue: string[] = [];
  Options?: { code: string; description: string }[] | string = null;
  ControlID: string;
  Type:
    | "combobox"
    | "text-input"
    | "date-picker"
    | "numeric"
    | "radio-button"
    | "checkbox"
    | "checkbox-list"
    | "multiselect" = "multiselect";
  Caption: string;
  Readonly: boolean;
  DataSourceRepo: { [key: string]: IDataSource<string> };

  constructor() {}

  Render(): ReactNode {
    let options: { code: string; description: string }[];
    if (typeof this.Options == "string")
      options = this.DataSourceRepo[this.Options].Read();
    else options = this.Options;

    return (
      <ControlledMultiselectComboBox
        caption={this.Caption}
        options={options}
        defaultValue={this.DefaultValue}
        onSelectionChange={(keys) => { this.CurrentValue = keys; }}
      />
    );
  }
}
